<template>
  <div class="content-picker-copy absolute">
    <div class="flex-start" v-if="detail">
      <div class="content-picker-copy-left">
        <div class="flex-center">
          <span class="inline-block name bold">
            <em class="normal inline-block">{{detail.nickname ? detail.nickname[0] : ''}}</em>
            {{detail.nickname}}
          </span>
          <span
            class="inline-block"
          >{{$t('400116',{amount: detail.thirtyOrderQuantity})}} | {{$t('400117',{num: fixNumberCopy(numMultiply(detail.thirtyCloseRate,100),2)})}}</span>
        </div>
        <div class="price-amount flex-between">
          <div class="price-time">
            <p style="margin-bottom: 12px">
              <span class="label">{{$t('400118')}}</span>
              <span class="value buyColor uppercase">{{detail.price}} {{detail.fiat}}</span>
            </p>
            <p>
              <span class="label">{{$t('400119')}}</span>
              <span class="value">{{payTimeListFilter(detail.expireTimeIndex)}}</span>
            </p>
          </div>
          <div class="amount-pay">
            <p style="margin-bottom: 12px">
              <span class="label">{{$t('400072')}}</span>
              <span class="value uppercase">{{detail.txAmount}} {{detail.currency}}</span>
            </p>
            <p class="pay-item">
              <span class="label">{{$t('400120')}}</span>
              <span class="value inline-block" v-for="p in detail.payments" :key="p.value">
                <em class="normal inline-block" :style="{ backgroundColor: p.extra }"></em>
                {{p.key}}
              </span>
            </p>
          </div>
        </div>
        <div class="trade-rule" v-if="detail.remark">
          <p class="trade-rule-title">{{$t('400121')}}</p>
          <pre class="trade-rule-content">{{detail.remark}}</pre>
        </div>
      </div>
      <div class="content-picker-copy-right">
        <div class="buy-box" v-if="status == 0">
          <div class="pay-input" :class="payAmountErrorMsg ? 'error-input' : ''">
            <!--我要支付-->
            <p>{{$t('400122')}}</p>
            <el-input v-model="totalAmount" placeholder="0.00" @input="totalAmountInput">
              <div
                :slot="isDirection?'prefix':'suffix'"
                class="uppercase"
                style="line-height: 24px"
              >{{detail.fiat}}</div>
            </el-input>
          </div>
          <span class="inline-block sellColor">{{payAmountErrorMsg}}</span>
          <div class="get-input" :class="payAmountErrorMsg ? 'error-input' : ''">
            <!--我将收到-->
            <p>{{$t('400123')}}</p>
            <el-input placeholder="0.00" v-model="payAmount" @input="payAmountInput">
              <div :slot="isDirection?'prefix':'suffix'" style="line-height: 24px">
                <el-button type="text" @click="allClick">{{$t('400074')}}</el-button>
                <span class="uppercase">{{detail.currency}}</span>
              </div>
            </el-input>
          </div>
        </div>
        <div class="sell-box" v-if="status == 1">
          <div class="get-input" :class="payAmountErrorMsg ? 'error-input' : ''">
            <!--我要卖-->
            <p>{{$t('400124')}}</p>
            <el-input placeholder="0.00" v-model="payAmount" @input="payAmountInput">
              <div :slot="isDirection?'prefix':'suffix'" style="line-height: 24px">
                <el-button type="text" @click="allClick">{{$t('400074')}}</el-button>
                <span class="uppercase">{{detail.currency}}</span>
              </div>
            </el-input>
          </div>
          <div class="pay-input" :class="payAmountErrorMsg ? 'error-input' : ''">
            <!--我将收到-->
            <p>{{$t('400123')}}</p>
            <el-input v-model="totalAmount" placeholder="0.00" @input="totalAmountInput">
              <div
                :slot="isDirection?'prefix':'suffix'"
                class="uppercase"
                style="line-height: 24px"
              >{{detail.fiat}}</div>
            </el-input>
          </div>
          <span class="inline-block sellColor">{{payAmountErrorMsg}}</span>
        </div>
        <div class="payment-method-box relative" v-if="status == 1">
          <!--支付方式-->
          <p class="label">{{$t('400125')}}</p>
          <!--设置收款方式-->
          <div
            class="payment-btn pointer"
            v-if="paymentMethodList.length == 0 && unSelectPaymentList.length == 0"
            @click="$router.push('/usercenter')"
          >{{$t('400126')}}</div>
          <div
            class="payment-input flex-between"
            v-else
            @click="paymentMethodListShow = !paymentMethodListShow"
          >
            <span>{{paymentLabel ? paymentLabel : $t('400149')}}&nbsp;&nbsp;&nbsp;&nbsp;{{paymentAccount}}</span>
            <i :class="paymentMethodListShow ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i>
          </div>
          <ul class="payment-method-list absolute" type="none" v-if="paymentMethodListShow">
            <li v-for="(item,index) in paymentMethodList" class="pointer" :key="index+'a'">
              <p
                v-for="inner in item.detail"
                :key="inner.id"
                class="flex-center"
                @click="handlePayment(item,inner)"
              >
                <span class="label">{{item.paymentName}}</span>
                <span class="value bold">{{inner.account}}</span>
              </p>
            </li>
            <li v-for="(item,index) in unSelectPaymentList" :key="index+'b'">
              <p v-for="inner in item.detail" :key="inner.id" class="flex-center unselect">
                <span class="label">{{item.paymentName}}</span>
                <span class="value bold">{{inner.account}}</span>
              </p>
            </li>
            <!--添加收款方式-->
            <router-link class="block" to="/usercenter">{{$t('400127')}}</router-link>
          </ul>
        </div>
        <!--参考单价{singlePay}-->
        <p class="reference-price" v-show="status == 0">{{$t('400128',{price:singlePay})}}</p>
        <div class="button-box flex-between">
          <el-button @click="closeModel" class="cancel-btn">{{$t('400096')}}</el-button>
          <el-button
            :disabled="isDisabled"
            :class="status == 0 ? 'buy-btn' : 'sell-btn'"
            @click="order"
          >{{status == 0 ? $t('400129') : $t('400130')}} {{detail.currency.toUpperCase()}}</el-button>
        </div>
        <span
          class="more block"
          v-show="status == 0 && item.tnStatus == 1"
        >{{$t('400131',{limit:`T+${detail.tnBan}`})}}</span>
        <a
          class="block"
          :href="language == 'zh-TC' ? 'https://support.superex.com/hc/zh-hk/articles/15191928483097' : 'https://support.superex.com/hc/en-001/articles/15202762191257'"
          v-show="status == 0 && item.tnStatus == 1"
        >
          {{$t('400132')}}
          <i class="el-icon-arrow-right" :class="{mirrorRotateLevel:isDirection}"></i>
        </a>
      </div>
    </div>
    <tipModel
      v-if="isAuthDialog"
      :cancelButton="false"
      :confirmButton="true"
      :confirmText="$t('400133')"
      @sureTip="isAuthDialog = false"
      @closeTip="isAuthDialog = false"
    >
      <!--根据您证件国和平台运营规范，请您切换到本国货币进行交易-->
      <p style="font-size: 14px;line-height: 1.5;margin: 16px 0 32px">{{$t('400134')}}</p>
    </tipModel>
    <tipModel
      v-if="errorTipModel"
      :cancelButton="false"
      :confirmButton="true"
      :confirmText="$t('400133')"
      @sureTip="errorTipModel = false"
      @closeTip="errorTipModel = false"
    >
      <p style="font-size: 14px;line-height: 1.5;margin: 16px 0 32px">{{errorTipMessage}}</p>
    </tipModel>
  </div>
</template>

<script>
import { fixNumberCopy, numDivide, numMultiply } from "@/plugins/methods";
import { exchange, getAdDetail, publishAd, paymentOptional } from "@/views/buycoin/api";
import { mapGetters } from "vuex";
import PaymentMethods from "@/views/buycoin/buycoin/components/PaymentMethods";
import tipModel from "@/components/publicModel/tipModel";
import { fetchExpireTime } from "@/views/myads/api";
import { myRegExpS } from "@/plugins/validate";
import { createOrderNewApi } from "@/apis/C2C";

export default {
  name: "ContentPickerCopy",
  components: {
    PaymentMethods,
    tipModel
  },
  props: {
    item: Object,
    status: Number
  },
  data() {
    return {
      receiveAmount: null,
      // 是否在编辑金额
      isChangeMoney: false,
      receiveMin: 0,
      receiveMax: 0,
      remark: "",
      detail: null,
      exchangeConfig: {},
      payAmountErrorMsg: '',
      isAuthDialog: false,
      payTimeList: [],
      config: {},
      totalAmount: '',
      payAmount: '',
      paymentMethodList: [],
      unSelectPaymentList: [],
      paymentLabel: '',
      paymentAccount: '',
      paymentId: '',
      paymentMethodListShow: false,
      errorTipMessage: '',
      errorTipModel: false,
      timer: null,
      requestLocked: false
    }
  },
  computed: {
    ...mapGetters(['C2CUserInfo', 'language', 'isDirection']),
    singlePay() {
      if (this.exchangeConfig.ratio === undefined) return undefined;
      return `${this.exchangeConfig.symbol}${this.exchangeConfig.ratio}`;
    },
    isDisabled() {
      if (this.status == 0) {
        return this.totalAmount == 0 || this.totalAmount == '' || this.payAmountErrorMsg != '' || this.payAmount == 0 || this.payAmount == ''
      } else {
        return this.totalAmount == 0 || this.totalAmount == '' || this.payAmountErrorMsg != '' || this.payAmount == 0 || this.payAmount == '' || this.paymentId == ''
      }
    }
  },
  watch: {
    'totalAmount': {
      deep: true,
      handler(newVal, OldVal) {
        if (!myRegExpS(newVal, this.config.fiatScale) && newVal != '') {
          this.$nextTick(() => {
            this.totalAmount = newVal.slice(0, -1)
          })
        }
        if (this.totalAmount == '' || this.totalAmount == 0) {
          this.payAmountErrorMsg = ''
        } else if (Number(this.totalAmount) < this.detail.minAmount || Number(this.totalAmount) > this.detail.maxAmount) {
          if (this.status == 0) {
            this.payAmountErrorMsg = this.$t('400135', { min: this.fixNumberCopy(this.detail.minAmount, this.config.fiatScale), max: this.fixNumberCopy(this.detail.maxAmount, this.config.fiatScale), fiat: this.detail.fiat.toUpperCase() })
          } else {
            this.payAmountErrorMsg = this.$t('400136', { min: this.fixNumberCopy(this.detail.minAmount, this.config.fiatScale), max: this.fixNumberCopy(this.detail.maxAmount, this.config.fiatScale), fiat: this.detail.fiat.toUpperCase() })
          }
        } else {
          this.payAmountErrorMsg = ''
        }
      }
    },
    'payAmount': {
      deep: true,
      handler(newVal, OldVal) {
        if (!myRegExpS(newVal, this.config.scale) && newVal != '') {
          this.$nextTick(() => {
            this.payAmount = newVal.slice(0, -1)
          })
        }
      }
    }
  },
  mounted() {
    console.log(this.isDirection)
    this.getDetail()
    // this.detail = this.item
    this.timer = setInterval(() => {
      this.getDetail()
    }, 30000)
    this.fetchExpireTime()
    this.getExchangeConfig()
    this.getConfig()
    if (this.status == 1) {
      this.getPaymentOptional()
    }
  },
  methods: {
    handlePayment(item, inner) {
      this.paymentLabel = item.paymentName
      this.paymentAccount = inner.account
      this.paymentId = inner.id
      this.paymentMethodListShow = false
    },
    payTimeListFilter(val) {
      return this.payTimeList.find(v => v.value == val) ? this.payTimeList.find(v => v.value == val).key : ''
    },
    fetchExpireTime() {
      fetchExpireTime({ type: "timeLimit" }).then(res => {
        this.payTimeList = res.timeLimit || []
      })
    },
    fixNumberCopy(value, unit) {
      return fixNumberCopy(value, unit)
    },
    numMultiply(arg1, arg2) {
      return numMultiply(arg1, arg2)
    },
    getPayId() {
      return this.$refs.PaymentMethods?.payment || null;
    },
    // 限定支付/收入最大最小值
    changeRate(key) {
      if (!key) return;
      if (key === "payAmount" && Number(this[key])) {
        if (this.payAmount > Number.parseInt(this.item.maxAmount || 0)) {
          // this.payAmount = Number.parseInt(this.item.maxAmount || 0);
        } else if (this[key] < Number.parseInt(this.item.minAmount || 0)) {
          // this.payAmount = Number.parseInt(this.item.minAmount || 0);
        }
      } else if (key === "receiveAmount" && Number(this[key])) {
        if (this[key] > Number.parseInt(this.receiveMax || 0)) {
          this[key] = Number.parseInt(this.receiveMax || 0);
        } else if (this[key] < Number.parseInt(this.receiveMin || 0)) {
          this[key] = Number.parseInt(this.receiveMin || 0);
        }
      }
    },
    NumberCheck(num) {
      var str = num;
      var len1 = str.substr(0, 1);
      var len2 = str.substr(1, 1);
      //如果第一位是0，第二位不是点，就用数字把点替换掉
      if (str.length > 1 && len1 == 0 && len2 != ".") {
        str = str.substr(1, 1);
      }
      //第一位不能是.
      if (len1 == ".") {
        str = "";
      }
      //限制只能输入一个小数点
      if (str.indexOf(".") != -1) {
        var str_ = str.substr(str.indexOf(".") + 1);
        if (str_.indexOf(".") != -1) {
          str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1);
        }
      }
      //正则替换，保留数字和小数点
      str = str.replace(/[^\d^\.]+/g, '')
      //如果需要保留小数点后两位，则用下面公式
      // str = str.replace(/\.\d\d$/,'')
      return str;
    },
    totalAmountInput() {
      this.payAmount = this.fixNumberCopy(numDivide(this.totalAmount, this.detail.price), this.config.scale)
    },
    payAmountInput() {
      this.totalAmount = this.fixNumberCopy(numMultiply(this.payAmount, this.detail.price), this.config.fiatScale)
    },
    // 点击全部
    allClick() {
      if (this.status == 0) {
        this.payAmount = this.fixNumberCopy(this.detail.txAmount, this.config.scale)
        this.totalAmount = this.fixNumberCopy(numMultiply(this.detail.txAmount, this.detail.price), this.config.fiatScale)
      } else {
        this.payAmount = this.fixNumberCopy(this.detail.txAmount, this.config.scale)
        this.totalAmount = this.fixNumberCopy(numMultiply(this.detail.txAmount, this.detail.price), this.config.fiatScale)
      }
    },
    order() {
      if (this.C2CUserInfo.tradableCurrency.toLowerCase() != this.item.fiat) {
        this.isAuthDialog = true
        return false
      }
      if (this.requestLocked) {
        return false
      }
      const params = {
        adId: this.detail.id,
        userPaymentId: this.status == 1 ? this.paymentId : undefined,
        quantity: this.fixNumberCopy(this.payAmount, this.config.scale),
        price: this.fixNumberCopy(this.detail.price, this.config.fiatScale),
        totalAmount: this.fixNumberCopy(this.totalAmount, this.config.fiatScale)
      }
      this.requestLocked = true
      createOrderNewApi(params).then(res => {
        console.log(res)
        if (res.data.code == 200) {
          this.closeModel()
          if (res.data.data) this.$router.push(`/order/${this.status}/${res.data.data}`);
          this.requestLocked = false
        } else if (res.data.code == 502) {
          this.errorTipMessage = res.data.msg
          this.errorTipModel = true
          this.requestLocked = false
        } else {
          this.$notify({
            message: res.data.msg,
            iconClass: 'iconfont icon-cuowu1',
            customClass: 'errorIcon flex-center',
            showClose: false,
            duration: 2000,
            position: this.isDirection ? 'top-left' : 'top-right'
          })
          this.requestLocked = false
        }
      }).catch(() => {
        this.requestLocked = false
      })
    },
    closeModel() {
      this.$emit('closeModel', this.item)
    },
    async getExchangeConfig() {
      const res = await exchange({
        currency: this.item.currency,
        fiat: this.item.fiat,
      });
      this.exchangeConfig = res;
    },
    async getDetail() {
      const res = await getAdDetail(this.item.id);
      this.detail = res;
    },
    async getConfig() {
      publishAd({ currency: this.item.currency, fiat: this.item.fiat }).then(res => {
        this.config = res
      })
    },
    getPaymentOptional() {
      paymentOptional().then(res => {
        if (res.length == 0) {
          this.paymentMethodList = []
          this.unSelectPaymentList = []
        } else {
          let hasIdArr = [];
          this.item.payments.forEach(({ value }) => hasIdArr.push(value));
          res.forEach((item) => {
            hasIdArr.includes(item.payment) && (this.paymentMethodList.push(item))
            !hasIdArr.includes(item.payment) && (this.unSelectPaymentList.push(item))
          })
          console.log(this.paymentMethodList, 'paymentMethodList')
          console.log(this.unSelectPaymentList, 'unSelectPaymentList')
        }
      })
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";
[dir="ltr"] .content-picker-copy {
  &-left {
    padding-right: 32px;

    .name {
      margin-right: 24px;

      em {
        margin-right: 12px;
      }
    }
    .price-amount {
      .price-time {
        .label {
          margin-right: 8px;
        }
      }
      .amount-pay {
        .label {
          margin-right: 8px;
        }
        .pay-item {
          .value {
            margin-right: 8px;
            em {
              margin-right: 4px;
            }
          }
        }
      }
    }
  }
  &-right {
    padding-left: 32px;

    border-left: 1px solid;
    @include border_color("border-color-normal");
    .pay-input,
    .get-input {
      ::v-deep .el-input__inner {
        padding-left: 0;
      }
    }

    .get-input {
      margin-bottom: 24px;
    }
    .button-box {
      .cancel-btn {
        margin-right: 12px;
      }
    }
    .payment-method-box {
      .payment-method-list {
        p {
          span.label {
            margin-right: 8px;
          }
        }

        .unselect {
          span.label {
            margin-right: 8px;
          }
        }
      }
    }
  }
}
[dir="rtl"] .content-picker-copy {
  &-left {
    padding-left: 32px;

    .name {
      margin-left: 24px;

      em {
        margin-left: 12px;
      }
    }
    .price-amount {
      // align-items: flex-end;
      .price-time {
        .label {
          margin-left: 8px;
        }
      }
      .amount-pay {
        .label {
          margin-left: 8px;
        }

        .pay-item {
          .value {
            margin-left: 8px;
            em {
              margin-left: 4px;
            }
          }
        }
      }
    }
  }
  &-right {
    padding-right: 32px;
    border-left: 1px solid;
    @include border_color("border-color-normal");
    .pay-input,
    .get-input {
      ::v-deep .el-input__inner {
        padding-right: 0;
      }
    }
    .button-box {
      .cancel-btn {
        margin-left: 12px;
      }
    }
    .payment-method-box {
      .payment-method-list {
        p {
          span.label {
            margin-left: 8px;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";
.content-picker-copy {
  width: 100%;
  height: auto;
  min-height: 388px;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.05);
  border: 1px solid;
  @include border_color("border-color-normal");
  border-radius: 4px;
  @include background_color("dialog-bg");
  z-index: 100;
  padding: 32px;
  &-left {
    width: calc(100% - #{468px});
    // padding-right: 32px;
    height: 100%;
    @include font_color("font-color");
    .name {
      font-size: $font-size-small;
      // margin-right: 24px;
      @include font_color("font-color");
      em {
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        border-radius: 50%;
        background-color: #ffc72b;
        font-size: $font-size-mini;
        // margin-right: 12px;
        color: $font-color-3;
      }
    }
    .price-amount {
      margin: 25px 0;
      align-items: flex-start;
      .price-time {
        width: 50%;
        .label {
          @include font_color("font-color-1");
          // margin-right: 8px;
          line-height: 1.5;
        }
        .value {
          @include font_color("font-color");
          line-height: 1.5;
        }
      }
      .amount-pay {
        width: 50%;
        .label {
          @include font_color("font-color-1");
          // margin-right: 8px;
          line-height: 1.5;
        }
        .value {
          @include font_color("font-color");
          line-height: 1.5;
        }
        .pay-item {
          .value {
            // margin-right: 8px;
            em {
              width: 4px;
              height: 12px;
              border-radius: 2px;
              // margin-right: 4px;
              vertical-align: -2px;
            }
          }
        }
      }
    }
    .trade-rule {
      width: 100%;
      &-content {
        margin-top: 8px;
        font-size: $font-size-mini;
        @include font_color("font-color-1");
        white-space: pre-wrap;
        width: 100%;
        height: 240px;
        overflow-y: auto;
      }
    }
  }
  &-right {
    width: 468px;
    padding-left: 32px;
    height: 388px;
    border-left: 1px solid;
    @include border_color("border-color-normal");
    .pay-input,
    .get-input {
      width: 100%;
      min-height: 78px;
      border: 1px solid;
      @include border_color("border-color-normal");
      border-radius: 4px;
      padding: 16px;
      p {
        margin-bottom: 8px;
        @include font_color("font-color");
      }
      &:hover {
        border-color: #ffc72b;
      }
      ::v-deep .el-input__suffix {
        @include font_color("font-color");
      }
      ::v-deep .el-button--text {
        padding: 0 10px 0;
      }
      ::v-deep .el-input__inner {
        border: none;
        background-color: transparent;
        font-size: 24px;
        font-weight: bold;
        padding-left: 0;
        height: 24px;
        line-height: 24px;
      }
    }
    .error-input {
      border-color: #fa4d56 !important;
    }
    .sellColor {
      margin: 8px 0 24px;
    }
    .get-input {
      margin-bottom: 24px;
    }
    .reference-price {
      font-size: $font-size-small;
      @include font_color("font-color-1");
    }
    .button-box {
      .cancel-btn {
        padding: 13px 0;
        width: 120px;
        margin-right: 12px;
        font-size: $font-size-small;
        @include font_color("font-color");
        @include background_color("button-bg-disabled");
        border: none;
      }
    }
    .more {
      font-size: $font-size-small;
      @include font_color("font-color-1");
      line-height: 1.5;
    }
    .payment-method-box {
      .payment-btn {
        padding: 14px 0;
        text-align: center;
        width: 100%;
        border: 1px solid;
        @include border_color("border-color-normal");
        color: $font-active-color;
        border-radius: 4px;
      }
      p.label {
        @include font_color("font-color-1");
        margin-bottom: 10px;
      }
      .payment-input {
        width: 100%;
        border: 1px solid;
        @include border_color("border-color-normal");
        border-radius: 4px;
        padding: 14px 16px;
        i {
          @include font_color("font-color-2");
        }
      }
      .payment-method-list {
        padding: 12px 0;
        width: 100%;
        @include background_color("dialog-down-bg");
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08),
          0px 2px 2px 0px rgba(0, 0, 0, 0.08);
        border-radius: 4px;
        border: 1px solid;
        @include border_color("border-color-normal");
        max-height: 192px;
        overflow-y: auto;
        p {
          padding: 14px 16px;
          span.label {
            @include font_color("font-color-2");
            margin-right: 8px;
          }
          span.value {
            @include font_color("font-color");
          }
        }
        a {
          text-align: center;
          text-decoration: underline;
        }
        .unselect {
          cursor: not-allowed;
          span.label {
            @include font_color("font-color-1");
            margin-right: 8px;
          }
          span.value {
            @include font_color("font-color-1");
          }
        }
      }
    }
    a {
      font-size: $font-size-small;
      color: $font-active-color;
      line-height: 1.5;
    }
    .buy-btn,
    .sell-btn {
      margin: 12px 0;
      width: 100%;
      padding: 13px 0;
      border: none;
    }
    ::v-deep .el-button.is-disabled {
      @include background_color("button-bg-disabled");
      @include font_color("font-color-1");
    }
    .buy-btn {
      background-color: $buy-color;
      color: $font-color-white;
    }
    .sell-btn {
      background-color: $sell-color;
      color: $font-color-white;
    }
  }
}
</style>